const INFO = {
	main: {
		title: "My Resume",
		name: "Sandeep Varma Indukuri.",
		email: "sandeepvarma531@gmail.com",
		// logo: "logo1.jpg",
	},

	socials: {
		twitter: "https://twitter.com/I_SandeepVarma",
		github: "https://github.com/Sandeep023",
		linkedin: "https://www.linkedin.com/in/sandeep-varma-indukuri/",
		instagram: "https://www.instagram.com/sandeepindukuri1997/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://www.facebook.com/indukuri.varma.771",
	},

	homepage: {
		title: "Full-stack web and mobile app developer, with all round expierience.",
		description:
			`I am a Full-Stack Developer with a Master's in Computer Science from Texas A&M University-Corpus Christi, 
			boasts extensive expertise in SDLC, specializing in developing and optimizing Spring and ReactJS-based applications. 
			Demonstrating rapid leadership ascent, I have led critical projects enhancing user interfaces and spearheading advancements in Computer Vision, ML, and AI, 
			contributing significantly to technological progress and fostering professional growth. 
			My technical acumen spans a wide range of tools and languages, including Java, ReactJS, Python, and AWS services.`,
	},

	about: {
		title: "I'm Sandeep Varma, constantly seeking to expand my knowledge and explore beyond the familiar horizons",
		description:
			`I am a proficient Full-Stack Developer with a solid foundation in computer science, holding a Master of Science degree from Texas A&M University-Corpus Christi and a Bachelor of Technology from the Indian Institute of Information Technology SriCity. With extensive experience spanning from 2018 to the present, I have expertise in all phases of the Software Development Life Cycle (SDLC), specializing in the design, development, and optimization of Spring applications and ReactJS-based full-stack web applications.
			
			Throughout my career, I have made significant contributions to the enhancement of user interfaces, leading to a 25% improvement in user experience, and have played a pivotal role in the architecture and implementation of REST-based Microservices using Spring Boot and Spring Data with JPA. My efforts have streamlined deployment and development workflows through the integration of continuous integration tools like Jenkins.
			
			My leadership skills were quickly recognized at Thingks Infomatics, where I assumed a critical role in project management within six months, driving advancements in Computer Vision, Machine Learning, and Artificial Intelligence. Additionally, as the leader of the Toastmasters club at Thingks Infomatics, I have been instrumental in fostering a culture of open dialogue and professional growth among peers.
			
			A strong proponent of best practices in code development and review, I have effectively reduced system loading times by 30% and enhanced performance across various devices, resulting in a 30% increase in user engagement and a 10% increase in revenue. His technical skills are broad and comprehensive, including C, C++, Java, ReactJS, Python, and AWS services, among others.
			
			My academic projects showcase my ability to apply theoretical knowledge to practical applications, with notable projects in outlier detection, location-based alarm systems, public transportation routing, and signature-based IDS systems for IoT networks. My dedication to technological advancement and my leadership in both professional and academic settings mark me as a distinguished individual in the field of Computer Science and Software Development.`,
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "E-Commerce",
			description:
				"An E-commerce Platform wher any user can register as seller and post things they want to sell, others can search and place order. Used frameworks like AWS services, ReactJs, JAVA",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/java/java.png",
			linkText: "View Project",
			link: "https://github.com",
		},
		{
			title: "Outlier Detection",
			description:
				"Outlier detection using a distance-based algorithm, forming clusters using a Minimum Spanning tree. This is developed using different libraries in python",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Location Based Allarm",
			description:
				"On contrary to the time-based alarm, we have developed an alarm system based on location of the user. This is developed using Android Studio amd java",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/java/java.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Public Transportation",
			description:
				"Collecting and applying the best path algorithm for all the public transportation routes in Hyderabad. This is developed using JAVA and algorithms are imlemented from scratch.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/java/java.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "Signature-based IDS",
			description:
				"A signature-based IDS system for IoT Networks using machine learning classifiers and regressions. This is developed using different libraries in python",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com",
		},

		{
			title: "White Space Compiler",
			description:
				"Designing and Developing a compiler for a programming language that uses only space, tab, new line. This is developed using C, LEX and YACC",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/c/c.png",
			linkText: "View Project",
			link: "https://github.com",
		},
	],
};
// https://cdn.jsdelivr.net/npm/programming-languages-logos@0.0.3/src/
export default INFO;
